// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-group[data-v-0a810ffe] {\n  text-align: center;\n  font-size: 200px;\n}\n.icon-tag[data-v-0a810ffe] {\n  width: 32px;\n  text-align: center;\n  margin-right: 5px;\n}", ""]);
// Exports
module.exports = exports;
